/*
This module provides some boilerplates for the Web Notification API. Some logic is handled outside of this library.

Three possible states (strings) of Notitification.permission:
* "default": allowed to prompt permission, but not send notifications.
* "denied": not allowed to prompt or send notifications.
* "granted": allowed to prompt permission and send permission.
NOTE: The user can change permission anytime through browser settings. This means that there
might be some discrapencies with redux state.
*/

const messages = {
    'new_entry': 'Nytt meddelande',
    'no_support': 'Den här webbläsaren stödjer inte skrivbordsnotifikationer. Du kan åtgärda detta genom att uppdatera din webbläsare.',
    'denied': 'Du har blockerat aviseringar från denna sidan. För att få aviseringar måste du tillåta det i din webbläsares inställningar',
    'blocked': 'Din webbläsare verkar blockera notifikationsförfrågningar. Vänligen tillåt notifikationer på denna hemsidan manuellt genom webbläsarens inställningar.'
}

function notify(title, sender, body) {
    title = messages[title]
    if (sender && body) body = sender + ': ' + body;
    else body = ''
    var options = {
        body: body,
        icon: '/images/webnotification_icon.png'
    }

    if (!("Notification" in window)) {
        return;
    }

    else if (Notification.permission === "granted") {
        // eslint-disable-next-line
        var notification = new Notification(title, options);
    }

    else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(function (permission) {
            if (permission === "granted") {
                // eslint-disable-next-line
                var notification = new Notification(title, options);
            }
        });
    }
}


function initialPromptPermission() {
    if ("Notification" in window && Notification.permission === "default") {
        Notification.requestPermission();
    }
}

/**
 * This function returns if notifications are permitted by the browser.
 * If they aren't it prompts the user to turn them on
 * If Notification.requestPermission() gets stuck a timeout-function informs
 *      the user that they need to do it manually (issue in Edge 27/7-2023)
 * Notification.requestPermission() use asynchronous promises.
 */
async function promptPermission(verbose=false) {
    let isResolved = false;
    if (!("Notification" in window)) {
        if (verbose) alert(messages['no_support']);
        return false;
    } else if (Notification.permission === "denied") {
        if (verbose) alert(messages['denied']);
        return false;
    } else if (Notification.permission === "default") {
        Notification.requestPermission().then(permission => {
            isResolved = true;
            return permission === "granted";
        });
        // Some browsers results in requestPermission() getting stuck.
        // If this happens the user should be prompted to change this setting manually.
        setTimeout((isResolved) => {
            if (!isResolved) {
              alert(messages['blocked']);
            }
          }, 500); // Waiting for 0.5 seconds before assuming it's blocked
    } else if (Notification.permission === "granted"){
        //If Notification is already granted.
        return true
    } else {
        // Should never get here but just in case...
        return false
    }
}

function checkPermission(verbose=false) {
    if (!("Notification" in window)) {
        if (verbose) alert(messages['no_support']);
        return null;
    }
    return Notification.permission;
}

export {
    notify,
    initialPromptPermission,
    promptPermission,
    checkPermission
};



// WEBPACK FOOTER //
// ./src/lib/WebNotification/notification.js